import styled from 'styled-components';

export const HomeWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #FFFCF4;
`;

export const HomeTitle = styled.h1`
  font-size: 2.5rem;
  color: #19334D;
  font-family: 'Playfair Display', serif;
`;

export const HeroSection = styled.div`
  width: 100vw;
  max-width: 100vw;
  background: linear-gradient(90deg, rgba(25,51,77,0.85) 0%, rgba(123,38,57,0.7) 100%), url('/assets/hero-bg.jpg') center/cover no-repeat;
  padding: 80px 0 60px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 0;
`;

export const HeroInner = styled.div`
  max-width: 980px;
  width: 100%;
  margin: 0 auto;
`;

export const WelcomeText = styled.h1`
  font-size: 3.2rem;
  font-family: 'Playfair Display', serif;
  color: #fff;
  font-weight: 700;
  margin-left: 0;
  margin-bottom: 18px;
`;

export const Subtitle = styled.p`
  font-size: 1.5rem;
  color: #f5f5f5;
  margin-left: 0;
  margin-bottom: 0;
  font-weight: 400;
`;

export const TwoColumnSection = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
  max-width: 980px;
  width: 100%;
  margin: 0 auto 40px auto;
`;

export const RightHeavySection = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1.8fr;
  gap: 24px;
  max-width: 980px;
  width: 100%;
  margin: 0 auto 40px auto;
`;

export const BalancedSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  max-width: 980px;
  width: 100%;
  margin: 0 auto 40px auto;
`;
